import { render, staticRenderFns } from "./TrustedShopsBadge.vue?vue&type=template&id=2f595f2e&"
import script from "./TrustedShopsBadge.vue?vue&type=script&lang=ts&"
export * from "./TrustedShopsBadge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports